import { Provider } from '@angular/core';
import { CommunicationService } from '../communication';
import { NotificationHandlerService } from 'projects/common/src/app/services';
import { ShiftCollectionService, UserDataService } from 'src/app/modules/core/services/parameter';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

/**
 * Provee la contrucción de una instancia del servicio que se encvargará de las
 * comunicaciones remotas y que implementará la interfaz de comunicaión remota
 *
 * IRemoteCommunication
 */
const shiftCollectionServiceFactory = (
  communicationService: CommunicationService,
  notificationHandlerService: NotificationHandlerService,
  userDataService: UserDataService,
  urlBuilderService: UrlBuilderService,
) => {
  return new ShiftCollectionService(communicationService, notificationHandlerService, userDataService, urlBuilderService);
};

/**
 * Provider que define el alias para la utilización del servicio que se encargará
 * de la comunicación remota y que implementará el método communicationServiceFactory
 * para la creación
 */
export const shiftCollectionServiceProvider: Provider = {
  provide: ShiftCollectionService,
  useFactory: shiftCollectionServiceFactory,
  deps: [CommunicationService, NotificationHandlerService, UserDataService, UrlBuilderService],
};
